
import { HashRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './component/Navbar/Navbar';
import Login from './component/Login/Login';
import Home from './component/Home/Home';

function App() {
  return (
    <>      
      <HashRouter>
        <Navbar/>
        <Routes>
          <Route path='/' element={<Login/>}/>
          {/* <Route path='/home' element={<Home/>}/> */}
        </Routes>
      </HashRouter>
    </>
  );
}

export default App;
